import { ReservationOptions } from "../configs";

const FALLBACK_PHONE = "+94778068626";

function getPhoneFromReservationOptions(): string {
  const callOption = ReservationOptions?.find(
    (option: { link?: string }) => option?.link?.startsWith("tel:")
  );

  if (callOption?.link) {
    return callOption.link.replace("tel:", "");
  }

  return FALLBACK_PHONE;
}

export function getDirectBookingPhone(): string {
  return getPhoneFromReservationOptions();
}

export function openWhatsAppOrCall(message?: string): void {
  const rawPhone = getPhoneFromReservationOptions();
  const waPhone = rawPhone.replace(/\D/g, "");
  const encodedMessage = encodeURIComponent(
    message ||
      "Hi Nutmeg Grove, I want to book directly on WhatsApp for the best available price."
  );

  const whatsappAppUrl = `whatsapp://send?phone=${waPhone}&text=${encodedMessage}`;
  const whatsappWebUrl = `https://wa.me/${waPhone}?text=${encodedMessage}`;
  const callUrl = `tel:${rawPhone}`;

  // Try native WhatsApp app, then WhatsApp web, and finally direct call.
  window.location.href = whatsappAppUrl;

  setTimeout(() => {
    if (!document.hidden) {
      window.location.href = whatsappWebUrl;

      setTimeout(() => {
        if (!document.hidden) {
          window.location.href = callUrl;
        }
      }, 900);
    }
  }, 900);
}
